import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from '../../apollo';
import {
  ProcessGoogleAuthCallbackMutation,
  ProcessGoogleAuthCallbackMutationVariables
} from './__generated__/ProcessGoogleAuthCallbackMutation';
import {
  ProcessFacebookAuthCallbackMutation,
  ProcessFacebookAuthCallbackMutationVariables
} from './__generated__/ProcessFacebookAuthCallbackMutation';

export const PROCESS_FACEBOOK_AUTH_CALLBACK_MUTATION = gql`
  mutation ProcessFacebookAuthCallbackMutation($code: String!) {
    processFacebookAuthCallback(code: $code) {
      success
      errors
    }
  }
`;

export const PROCESS_GOOGLE_AUTH_CALLBACK_MUTATION = gql`
  mutation ProcessGoogleAuthCallbackMutation($code: String!) {
    processGoogleAuthCallback(code: $code) {
      success
      errors
    }
  }
`;

export const useProcessFacebookAuthCallback = () => {
  return useMutation<ProcessFacebookAuthCallbackMutation, ProcessFacebookAuthCallbackMutationVariables>(
    PROCESS_FACEBOOK_AUTH_CALLBACK_MUTATION,
    {
      client: kmsClient
    }
  );
};
export const useProcessGoogleAuthCallback = () => {
  return useMutation<ProcessGoogleAuthCallbackMutation, ProcessGoogleAuthCallbackMutationVariables>(
    PROCESS_GOOGLE_AUTH_CALLBACK_MUTATION,
    {
      client: kmsClient
    }
  );
};
